<template>
  <div>
    <input
      id="user-id"
      type="hidden"
      v-model="categoria.usuario"
    />
    <input
      id="categoria-id"
      type="hidden"
      v-model="categoria.id"
    />
    <input
      id="categoria-uuid"
      type="hidden"
      v-model="categoria.uuid"
    />
    <v-row>
      <v-col
        cols="12"
        md="8"
      >
        <v-text-field
          v-model="categoria.categoria"
          label="Categoria"
          outlined
          required
          dense
          hint="Observação: escrever todo o nome em caixa baixa e sem acentuação"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="8"
      >
        <v-textarea
          v-model="categoria.ds_categoria"
          label="Descrição"
          auto-grow
          outlined
          rows="3"
          row-height="25"
          dense
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'FormCategoria',
  props: {
    categoria: {}, mode: { type: String, default: 'save' }
  }
}
</script>
